import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import CurrencyConverter from '../CurrencyConverter';
import { injectIntl, FormattedMessage } from 'react-intl';
import { DayPicker, addToRange } from 'react-day-picker';
import { pt, he, es, en, it, fr, ar } from "react-day-picker/locale";
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button } from 'react-bootstrap';

import SaveCalendar from './SaveCalendar';

import { isRTL } from '../../helpers/formatLocale';
import { getDateUsingTimeZone } from '../../helpers/dateRange';
import messages from '../../locale/messages';
import s from "react-day-picker/style.css";
import t from '../../styles/becomeHostCalendar.css';

const localeArray = {
  'en-US': en,
  'es': es,
  'it-IT': it,
  'fr-FR': fr,
  'pt-PT': pt,
  'ar': ar,
  'he': he
};


class DayDragCalendar extends Component {

  static propTypes = {
    change: PropTypes.func,
    formName: PropTypes.string,
    disabledDates: PropTypes.array,
    blockedDates: PropTypes.array,
  };

  static defaultProps = {
    disabledDates: [],
    blockedDates: [],
    listId: null,
    sources: []
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDays: [],
      from: undefined,
      to: undefined,
      dateRange: [],
      chooseRangeDate: [],
      isPrice: [],
      sources: [],
      month: null
    };
    this.isDaySelected = this.isDaySelected.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.resetCalendar = this.resetCalendar.bind(this);
    this.resetDatePickerChange = this.resetDatePickerChange.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
  }

  componentDidMount() {
    this.setState({ month: moment() })
  }

  UNSAFE_componentWillMount() {
    const { blockedDates, sources, availableDatesPrices } = this.props;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }

    let sourcesValue = [];
    let sourceObject = {};

    availableDatesPrices && availableDatesPrices.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.date;
      sourcesValue.push(sourceObject);
    });

    this.setState({ sources: sourcesValue });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { blockedDates, sources, availableDatesPrices } = nextProps;
    if (blockedDates != undefined) {
      this.setState({ selectedDays: blockedDates });
    }
    let sourcesValue = [];
    let sourceObject = {};

    availableDatesPrices && availableDatesPrices.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.date;
      sourcesValue.push(sourceObject);
    });

    this.setState({ sources: sourcesValue });

  }

  scrollTop() {
    window.scrollTo({
      top: 700,
      behavior: 'smooth'
    })
  }

  renderDay = (props) => {
    const { currency, basePrice, weekendPrice } = this.props;
    const { sources } = this.state;
    let specialPrice = sources?.find((item, key) => moment(props['data-day']).format('YYYY-MM-DD') == moment(item.blockedDates).format('YYYY-MM-DD'));

    // Determine the price to display
    let displayPrice;
    if (specialPrice) {
      // Special price has highest priority
      displayPrice = specialPrice.isSpecialPrice;
    } else {
      // Check if day is Friday (5) or Saturday (6)
      const dayOfWeek = moment(props['data-day']).day();
      displayPrice = (dayOfWeek === 5 || dayOfWeek === 6) && weekendPrice ? weekendPrice : basePrice;
    }

    return (
      <td class={props.className} role={props?.role} data-day={props['data-day']}>
        {props.children}
        {displayPrice &&
          <div className='priceAlignment'>
            <CurrencyConverter
              amount={displayPrice}
              from={currency}
            />
          </div>
        }
      </td>
    );
  }


  isDaySelected(day) {
    const { selectedDays } = this.state;
    if (selectedDays && selectedDays.length > 0) {
      return selectedDays.some(selectedDay =>
        moment(selectedDay).isSame(day)
      );
    }
  }

  async handleDayClick(day, { selected, disabled }) {
    const { blockedDates, change, formName, isEndDate } = this.props;
    let selectedDays = blockedDates.slice();
    let startDate, endDate;
    let dateRange = [], rangeStart, rangeEnd;

    if (disabled) return;

    const range = addToRange(day, this.state, 1);
    startDate = range?.from;
    endDate = range?.to;

    startDate = new Date(range?.from);
    startDate.setHours(12, 0, 0, 0);
    if (range?.to) {
      endDate = new Date(range?.to);
      endDate.setHours(12, 0, 0, 0);
    }

    if (!range || (isEndDate && moment(startDate).isSame(isEndDate))) {
      startDate = null;
      endDate = null;
      dateRange, selectedDays = [];
    } else if (startDate && !endDate) {
      rangeStart = new Date(startDate);
      dateRange.push(rangeStart);
    } else if (startDate && endDate) {
      rangeStart = new Date(startDate);
      rangeEnd = new Date(endDate);

      if (!moment(rangeStart).isSame(rangeEnd)) {
        dateRange.push(rangeStart);

        rangeStart = new Date(+rangeStart);

        while (rangeStart < endDate) {

          dateRange.push(rangeStart);
          var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
          rangeStart = new Date(newDate);
        }
      } else {
        startDate = null;
        endDate = null;
        dateRange, selectedDays = [];
      }
    }

    const isBrowser = typeof window !== 'undefined';
    let smallDevice = isBrowser ? window.matchMedia('(max-width: 768px)').matches : true;
    if (smallDevice) this.scrollTop();

    this.setState({ selectedDays, dateRange, from: startDate, to: endDate });

    change('ListPlaceStep3', 'startDate', startDate)
    change('ListPlaceStep3', 'endDate', endDate)
  }

  resetCalendar() {
    const { change } = this.props;
    // this.setState({ dateRange: [], from: null, to: null, startDate: null, endDate: null });
    this.setState({ dateRange: [], from: null, to: null, startDate: null, endDate: null });
    change('ListPlaceStep3', 'startDate', null)
    change('ListPlaceStep3', 'endDate', null)
  }

  resetDatePickerChange() {
    const { change } = this.props;
    this.setState({ dateRange: [], from: null, to: null });
  }

  setNextMonth = () => {
    this.setState({ month: moment(this.state.month).add(1, 'month') });
  }

  setPrevMonth = () => {
    const monthData = moment(this.state.month).subtract(1, 'month');
    if (moment(monthData).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
      this.setState({ month: monthData });
    }
  }

  handleTodayClick = () => {
    this.setState({ month: moment() })
  }

  render() {
    const { selectedDays, from, to, dateRange, month } = this.state;
    const { disabledDates, formName, listId, availableDates, todayLabel, halfDates } = this.props;
    const { minNight, maxNight, houseRules, checkInEnd, checkInStart, locale } = this.props;
    const { cancellationPolicy, maxDaysNotice, bookingNoticeTime, weeklyDiscount, monthlyDiscount } = this.props;
    const { cleaningPrice, basePrice, currency, tax } = this.props;
    const { isStartDate, isEndDate, country } = this.props;
    let listCountryDate = getDateUsingTimeZone(country, false);
    let today = new Date(listCountryDate.get('year'), listCountryDate.get('month'), listCountryDate.get('date'), listCountryDate.get('hour'), listCountryDate.get('minute'), listCountryDate.get('second'));

    const modifiers = {
      start: from,
      end: to,
      blocked: selectedDays,
      selecting: dateRange,
      available: availableDates,
      availableStart: halfDates && halfDates.secondHalfAvailable,
      availableEnd: halfDates && halfDates.firstHalfAvailable,
      bookedStart: halfDates && halfDates.secondHalfDisabled,
      bookedEnd: halfDates && halfDates.firstHalfDisabled,
      booked: disabledDates,
      disabled: [
        { before: new Date() }, ...disabledDates
      ],
      secondHalfBlocked: halfDates && halfDates.secondHalfBlocked,
      firstHalfBlocked: halfDates && halfDates.firstHalfBlocked,
    };

    const modifiersClassNames = {
      blocked: 'fullyBlocked',
      selecting: 'customDayCalendarSelecting',
      available: 'fullyAvailable',
      availableStart: 'secondHalfAvailable',
      availableEnd: 'firstHalfAvailable',
      bookedStart: 'secondHalfBooked',
      bookedEnd: 'firstHalfBooked',
      booked: 'fullyBooked',
      secondHalfBlocked: 'secondHalfBlocked',
      firstHalfBlocked: 'firstHalfBlocked',
      start: 'selectingStart',
      end: 'selectingEnd',
      disabled: 'disabledDates'
    }

    const customBecomeHostDayPickerClass = {
      nav: "becomeHostMonthNav",
      month_caption: "becomeHostMonthCaption",
      caption_label: "becomeHostMonthCaptionLabel",
      months: "becomeHostMonthsGroup",
      month_grid: 'becomeHostMonthTable',
      weekdays: 'becomeHostWeekdaysGroup',
      weekday: 'weekdaySection',
      month: 'becomeHostSingleMonth',
      weeks: "becomeHostWeeksGrpBody",
      week: "becomeHostSingleWeek",
      day: "becomeHostSingleDay",
      day_button: "becomeHostInnerDayBtn",
      button_previous: "becomeHostMonthNavPrevBtn",
      button_next: "becomeHostMonthNavNextBtn",
      chevron: 'chevronHidden',
      selected: null,
      range_start: null,
      range_middle: null,
      range_end: null
    };

    return (
      <Row>
        <Col lg={8} md={12} sm={12} xs={12} className={'saveCalender becomeHostCalendarCol1'}>
          <div className={'becomeHostCalendarBox'}>
            <Button onClick={() => this.handleTodayClick()} className='becomeHostCalendarTodayBtn'>
              <FormattedMessage {...messages.todayLabel} />
            </Button>
            <DayPicker
              month={month}
              selected={[this.isDaySelected, from, { from, to }]}
              mode="range"
              onDayClick={this.handleDayClick}
              modifiers={modifiers}
              disabled={{ before: new Date() }}
              disabledDays={[...disabledDates]}
              components={{ Day: this.renderDay }}
              locale={localeArray[locale]}
              startMonth={moment()}
              className={'becomeHostCalendarContainer'}
              classNames={customBecomeHostDayPickerClass}
              transitionDuration={0}
              dir={isRTL(locale) ? 'rtl' : 'ltr'}
              onNextClick={this.setNextMonth}
              onPrevClick={this.setPrevMonth}
              modifiersClassNames={modifiersClassNames}
            />
          </div>
        </Col>
        <Col lg={4} md={6} sm={6} xs={12} className='becomeHostCalendarCol2'>
          <SaveCalendar
            selectedDays={dateRange}
            start={from}
            end={to}
            formName={formName}
            resetCalendar={this.resetCalendar}
            resetDatePickerChange={this.resetDatePickerChange}
            listId={listId}
            minNight={minNight}
            maxNight={maxNight}
            houseRules={houseRules}
            checkInEnd={checkInEnd}
            checkInStart={checkInStart}
            cancellationPolicy={cancellationPolicy}
            maxDaysNotice={maxDaysNotice}
            bookingNoticeTime={bookingNoticeTime}
            cleaningPrice={cleaningPrice}
            basePrice={basePrice}
            currency={currency}
            isStartDate={isStartDate}
            isEndDate={isEndDate}
            tax={tax}
            weeklyDiscount={weeklyDiscount}
            monthlyDiscount={monthlyDiscount}
          />
        </Col>
      </Row>
    );
  }

}


const selector = formValueSelector('ListPlaceStep3');
const step1FormSelector = formValueSelector('ListPlaceStep1');

const mapState = (state) => ({
  isStartDate: selector(state, 'startDate'),
  isEndDate: selector(state, 'endDate'),
  locale: state.intl.locale,
  country: step1FormSelector(state, 'country'),
  halfDates: selector(state, 'halfDates'),
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, t)(connect(mapState, mapDispatch)(DayDragCalendar)));